<template>
  <v-app class="auth-page auth-page--neutral">
    <v-container fluid class="auth-split__panel pa-0">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="5">
          <v-card class="auth-card" elevation="0">
            <div class="auth-card__header">
              <h1 class="auth-card__title">Solicitar cancelamento de conta</h1>
              <p class="auth-card__subtitle">
                Informe seus dados para que nossa equipe analise a solicitação.
              </p>
            </div>

            <v-card-text class="auth-card__body">
              <v-alert type="warning" outlined dense class="mb-4">
                <strong>Atenção:</strong> Esta ação não pode ser desfeita. Ao solicitar o cancelamento, sua conta será
                desativada após análise.
              </v-alert>

              <v-form ref="form" v-model="valid" @submit.prevent="handleRequestCancellation">
                <v-text-field
                  v-model="document"
                  label="Documento do parceiro (CPF/CNPJ)"
                  outlined
                  dense
                  class="br-form-field mb-2"
                  :rules="documentRules"
                  placeholder="Digite o CPF ou CNPJ"
                  v-mask="document.replace(/\D/g, '').length <= 11 ? '###.###.###-##' : '##.###.###/####-##'"
                />

                <v-textarea
                  v-model="reason"
                  label="Motivo do cancelamento"
                  outlined
                  dense
                  rows="5"
                  class="br-form-field"
                  :rules="reasonRules"
                  placeholder="Por favor, informe o motivo do cancelamento da sua conta..."
                  counter
                  maxlength="500"
                />

                <v-btn
                  type="submit"
                  :disabled="!valid || loading"
                  :loading="loading"
                  :dark="valid"
                  color="primary"
                  depressed
                  block
                  large
                  class="mt-4"
                >
                  <v-icon left>mdi-send</v-icon>
                  Solicitar cancelamento
                </v-btn>

                <v-btn type="button" text color="grey darken-1" block class="mt-2" @click="goBack">
                  Voltar
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RequestAccountCancellation } from "@/services/user/RequestAccountCancellation";

export default defineComponent({
  data() {
    return {
      valid: false,
      document: "",
      reason: "",
      loading: false,
      documentRules: [
        (value: string) => {
          if (!value || value.trim().length === 0) {
            return "O documento é obrigatório";
          }
          const cleanDocument = value.replace(/\D/g, "");
          if (cleanDocument.length !== 11 && cleanDocument.length !== 14) {
            return "O documento deve ser um CPF (11 dígitos) ou CNPJ (14 dígitos)";
          }
          return true;
        },
      ],
      reasonRules: [
        (value: string) => {
          if (!value || value.trim().length === 0) {
            return "O motivo é obrigatório";
          }
          if (value.trim().length < 10) {
            return "O motivo deve ter pelo menos 10 caracteres";
          }
          return true;
        },
      ],
    };
  },
  methods: {
    async handleRequestCancellation() {
      if (!this.valid) {
        return;
      }

      this.loading = true;

      try {
        const cleanDocument = this.document.replace(/\D/g, "");
        const requestCancellation = new RequestAccountCancellation();
        const result = await requestCancellation.execute(cleanDocument, this.reason.trim());

        console.log("✅ Solicitação de cancelamento processada:", result);

        this.$router.push("/account/cancellation-confirmation");
      } catch (error: unknown) {
        console.error("Erro ao solicitar cancelamento:", error);
        const err = error as { message?: string };
        const errorMessage =
          err.message || "Erro ao solicitar cancelamento. Tente novamente.";

        this.$store.dispatch("showSnack", {
          message: errorMessage,
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.push("/login");
    },
  },
});
</script>
